// @flow
import { type CoreDatum as ChannelUgcItem } from '../../ducks/coreDataReducer';

const sortByNewestContent = (items: Array<ChannelUgcItem>) =>
  items.sort(
    (item1, item2) =>
      new Date(item2.ugc.created_date).getTime() -
      new Date(item1.ugc.created_date).getTime()
  );

const sortByOldestContent = (items: Array<ChannelUgcItem>) =>
  items.sort(
    (item1, item2) =>
      new Date(item1.ugc.created_date).getTime() -
      new Date(item2.ugc.created_date).getTime()
  );

export const ChannelContentSortTypeOptions = {
  SortByNewest: {
    label: 'Newest',
    value: 'SortByNewest',
    sortFunction: sortByNewestContent,
  },
  SortByOldest: {
    label: 'Oldest',
    value: 'SortByOldest',
    sortFunction: sortByOldestContent,
  },
};

export const ChannelContentSortDropdownOptions = [
  ChannelContentSortTypeOptions.SortByOldest,
  ChannelContentSortTypeOptions.SortByNewest,
];



// WEBPACK FOOTER //
// ./src/containers/channels/channelContentSortUtils.js